// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3giAG","select":"Header_select__2bE2b","clinic":"Header_clinic__nb2lK"};